var path = '/components/components/al-switch/component.tpl.html';
var html = "<span class=\"before-switch\" ng-click=\"vm.model = false\">{{::vm.internalConfig.falseLabel}}</span>\n\n<switch name=\"{{vm.internalConfig.name}}\" id=\"{{vm.internalConfig.name}}\" ng-model=\"vm.model\"\n        disabled=\"vm.internalConfig.disabled\"\n        ng-change=\"vm.changeAction(vm.model)\"></switch>\n<span class=\"after-switch\" ng-click=\"vm.model = true\">{{::vm.internalConfig.trueLabel}}</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/al-switch/component.tpl.html
// module id = 1960
// module chunks = 1